import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { convertToNumber } from "./utils/convertToNumber";

export function probitLocks(states: Partial<EvaChartStates>) {
  const { locks } = states;
  const lockedXMin =
    locks?.xMin?.type === DataEnum.Reset ? undefined : locks?.xMin?.value;
  const lockedXMax =
    locks?.xMax?.type === DataEnum.Reset ? undefined : locks?.xMax?.value;
  const lockedYMin = locks?.yMin?.value;
  const lockedYMax =
    locks?.yMax?.type === DataEnum.Reset ? undefined : locks?.yMax?.value;

  return {
    lockedXMin: convertToNumber(lockedXMin),
    lockedXMax: convertToNumber(lockedXMax),
    lockedYMin: convertToNumber(lockedYMin),
    lockedYMax: convertToNumber(lockedYMax)
  };
}
